export default [
  {
    path: '/veiculos',
    name: 'fleetVehicle',
    component: () => import(/* webpackChunkName: "fleet" */ './List.vue'),
    meta: { auth: true }
  },
  {
    path: '/veiculos/novo',
    name: 'fleetVehicle/novo',
    component: () => import(/* webpackChunkName: "fleet" */ './Add.vue'),
    meta: { auth: true }
  },
  {
    path: '/veiculos/:id',
    name: 'fleetVehicle/editar',
    component: () => import(/* webpackChunkName: "fleet" */ './Edit.vue'),
    meta: { auth: true }
  },
  {
    path: '/veiculos/:id/remover',
    name: 'fleetVehicle/remover',
    component: () => import(/* webpackChunkName: "fleet" */ './Remove.vue'),
    meta: { auth: true }
  }
]
